import _slicedToArray from "D:\\agent\\_work\\82\\s\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import React, { useState, forwardRef, useImperativeHandle } from "react";
import { createStyles, Button } from "@material-ui/core";
import { withStyles } from "@material-ui/styles";
import { colors, fonts } from "../theme";
import { darken } from "@material-ui/core/styles";
import clsx from "clsx";
import { formatId } from "./formatters";
var styles = function styles(theme) {
  return createStyles({
    button: {
      boxShadow: "0px 1px 3px 0px rgba(0,0,0,0.2),0px 1px 1px 0px rgba(0,0,0,0.14),0px 2px 1px -1px rgba(0,0,0,0.12)",
      color: colors.white
    },
    expandedButton: {
      backgroundColor: colors.deepSeaBlue,
      "&:hover": {
        background: darken(colors.deepSeaBlue, 0.1)
      }
    },
    hiddenButton: {
      backgroundColor: colors.powderBlue,
      "&:hover": {
        background: darken(colors.powderBlue, 0.1)
      }
    },
    buttonLabel: Object.assign(Object.assign({}, fonts.fontStyles.subPanelFont), {
      display: "block",
      lineHeight: 1,
      padding: "0 0.5em",
      textAlign: "center"
    }),
    container: {
      width: "100%"
    },
    panel: {
      overflow: "hidden",
      padding: "0.5em 1em"
    },
    expanded: {
      transition: "transform 150ms ease",
      transformOrigin: "top",
      transform: "scaleY(1)"
    },
    hidden: {
      maxHeight: 0,
      transition: "transform 150ms ease",
      transformOrigin: "top",
      transform: "scaleY(0)"
    },
    icon: {
      color: colors.white,
      marginRight: "0.25em",
      verticalAlign: "text-bottom"
    },
    error: {
      border: "thin solid ".concat(colors.candyRed)
    }
  });
};
var SecondaryExpansionPanel = forwardRef(function (props, ref) {
  var classes = props.classes,
    children = props.children,
    defaultExpanded = props.defaultExpanded,
    title = props.title,
    id = props.id,
    _props$error = props.error,
    error = _props$error === void 0 ? false : _props$error;
  var _useState = useState(defaultExpanded !== undefined ? defaultExpanded : false),
    _useState2 = _slicedToArray(_useState, 2),
    expanded = _useState2[0],
    setExpanded = _useState2[1];
  useImperativeHandle(ref, function () {
    return {
      expand: function expand() {
        setExpanded(true);
      }
    };
  });
  return React.createElement("div", {
    className: classes.container
  }, React.createElement(Button, {
    id: id ? id : formatId(title),
    className: error ? classes.error : "",
    classes: {
      root: clsx(classes.button, expanded ? classes.expandedButton : classes.hiddenButton),
      label: classes.buttonLabel
    },
    fullWidth: true,
    onClick: function onClick() {
      return setExpanded(!expanded);
    }
  }, title), React.createElement("div", {
    className: clsx(classes.panel, expanded ? classes.expanded : classes.hidden)
  }, expanded && children));
});
export default withStyles(styles)(SecondaryExpansionPanel);